module.exports = __webpack_public_path__ + "assets/img/carousel-1-640.e33f1afd.webp";